import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMapLayer, selectEventsList, makeFilterNetwork } from "state/actionsCreators";

import SwitchesList from "Components/Atoms/A_EQViewer/SwitchesList";
import build_settings_label from "Components/Atoms/A_Reusable/SettingsSwith";

const DEFAULT_EVENT_LIST_SELECTED_CODE = 2;

const MapSettingsPanelVolcano = () => {

	const mapLayers = useSelector( state => state.mapLayers );
	const networksEq = useSelector( state => state.networksEq );
	const networkFilters = useSelector( state => state.network_filters );
	const showNetWork = false;

	const dispatch = useDispatch();
	
	const selectDefaultList = () => dispatch( selectEventsList( DEFAULT_EVENT_LIST_SELECTED_CODE ) );
	const handleSelectLayerOption = layerItem => dispatch( setMapLayer( layerItem ) );
	
	const handleNetwork_filters = item_filter => {
		item_filter.selected === false
		? dispatch( makeFilterNetwork({
				type: true,
				value: item_filter.value,
				function: item_filter.function,
				index: item_filter.id - 1
			}))
			: dispatch( makeFilterNetwork({
				type: false,
				value: item_filter.value,
				index: item_filter.id - 1
			}));
		}

	useEffect(() => {
		handleSelectLayerOption( mapLayers[2] );
		selectDefaultList();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ setMapLayer ]);

	return (
		<div className="MapSettingsPanelVolcano">

		<div className="MapSettingsSection">
			<div className="SectionTitleContainer">
				<h6 className="SectionTitle">Capas del mapa</h6>
			</div>
			<SwitchesList
				items = { mapLayers }
				labelValue = "name"
				label_switch = { build_settings_label }
				onChange = { handleSelectLayerOption }
				unique
				required
			/>
		</div>
		{
			showNetWork === true && networkFilters.filters && (
				<div className="MapSettingsSection">
					<div className="SectionTitleContainer">
						<h6 className="SectionTitle">Red de monitoreo</h6>
					</div>
					<SwitchesList
						items = { networksEq }
						labelValue = "name"
						label_switch = { build_settings_label }
						onChange = { handleNetwork_filters }
						unique = { false }
						required = { false }
					/>
				</div>
			)
		}
	</div>
	);
};

export default MapSettingsPanelVolcano;
